import { FC, useContext } from "react";

import {
  DateContainer,
  DateTitle,
  Icon,
  InputLabel,
  InputTime,
  TimeContainer,
  TimeTitle,
} from "./DatePicker.styled";
import { DayPicker, DateRange } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { clock } from "../../../assets/icon";
import { useTranslation } from "../../../hooks/useTranslation";

import * as local from 'date-fns/locale';
import { QuizContext } from "../../../providers/QuizProvider/QuizContext";
//import { useTranslation } from "react-i18next";


export interface DateTimeDataInfo {
  date: Date | DateRange | undefined;
  time: { from?: string; to?: string } | undefined;
}

type Props = {
  value: DateTimeDataInfo;
  onChange: (value: DateTimeDataInfo) => void;
  date_range: boolean;
  with_time: boolean;
};

export const DatePicker: FC<Props> = ({
  value,
  date_range,
  with_time,
  onChange,
}) => {
  const { t } = useTranslation();
  const { language_code } = useContext(QuizContext);
  // const today = new Date();
  // const [selectedDay, setSelectedDay] = useState<Date | undefined>(today);

  // const defaultSelected: DateRange = {
  //   from: undefined, // today,
  //   to: undefined, // addDays(today, 2),
  // };
  // const [range, setRange] = useState<DateRange | undefined>(defaultSelected);

  return (
    <>
      <DateContainer>
        <DateTitle>{t("chooseDate")}</DateTitle>
        {date_range ? (
          <DayPicker
            showOutsideDays
            fixedWeeks
            weekStartsOn={1}
            mode="range"
            locale={(local as any)[language_code] ?? local.enGB}
            selected={value.date as DateRange | undefined}
            onSelect={(date) => onChange({ ...value, date })}
          />
        ) : (
          <DayPicker
            showOutsideDays
            fixedWeeks
            weekStartsOn={1}
            locale={(local as any)[language_code] ?? local.enGB}
            mode="single"
            required
            selected={value.date as Date | undefined}
            onSelect={(date) => onChange({ ...value, date })}
          />
        )}
      </DateContainer>
      {with_time && (
        <TimeContainer>
          <InputLabel>
            <TimeTitle>{t("chooseTimeFrom")}</TimeTitle>
            <InputTime
              id="time-from"
              type="time"
              name="time"
              required
              value={value.time?.from ?? ""}
              onChange={({ target }) => {
                onChange({
                  ...value,
                  time: { ...value.time, from: target.value },
                });
              }}
            />
            <Icon src={clock} width={14} height={14} title="clock button" />
          </InputLabel>

          <InputLabel>
            <TimeTitle>{t("chooseTimeTo")}</TimeTitle>
            <InputTime
              id="time-from"
              type="time"
              name="time"
              required
              value={value.time?.to ?? ""}
              onChange={({ target }) => {
                onChange({
                  ...value,
                  time: { ...value.time, to: target.value },
                });
              }}
            />
            <Icon src={clock} width={14} height={14} title="clock button" />
          </InputLabel>
        </TimeContainer>
      )}
    </>
  );
};
